import { z } from "zod";

/**
 * Zod schema for numeric ranges that are either empty or contain exactly two numbers.
 */
export const valueRangeArray = z
    .array(z.number())
    .refine((acceptableValueRange) => acceptableValueRange.length === 0 || acceptableValueRange.length === 2, {
        message: "Value range must be empty or contain exactly 2 numbers",
    });
